import { FeedbackPlacement } from "../constants/feedback";
import type {
    FeedbackInsightIdentifier,
    FeedbackMetadata,
    StoredFeedback,
} from "../types/feedback";

export const getInsightIdentifierString = (
    insightIdentifier: FeedbackInsightIdentifier,
): string => {
    return `${insightIdentifier.identifier}_${insightIdentifier.insightType}`;
};

export const submitFeedback = (
    insightIdentifier: FeedbackInsightIdentifier,
    metadata: FeedbackMetadata,
    rating: number,
    placement: FeedbackPlacement = FeedbackPlacement.SIDE_PANEL_WITH_METADATA,
): void => {
    const feedbackStored = localStorage.getItem(placement);
    let feedbackMap: { [key: string]: StoredFeedback[] } = {};
    if (feedbackStored !== null) {
        feedbackMap = { ...JSON.parse(feedbackStored) };
    }
    const insightIdentifierString =
        getInsightIdentifierString(insightIdentifier);

    if (!feedbackMap[insightIdentifierString]) {
        feedbackMap[insightIdentifierString] = [];
    }

    feedbackMap[insightIdentifierString].push({
        rating,
        metadata,
    });
    localStorage.setItem(placement, JSON.stringify(feedbackMap));
};

export const feedbackSubmitted = (
    insightIdentifier: FeedbackInsightIdentifier,
    metadata: FeedbackMetadata,
    placement: FeedbackPlacement = FeedbackPlacement.SIDE_PANEL_WITH_METADATA,
): number | null => {
    const feedbackStored = localStorage.getItem(placement);
    if (feedbackStored !== null) {
        const feedbackMap: { [key: string]: StoredFeedback[] } = {
            ...JSON.parse(feedbackStored),
        };
        const insightIdentifierString =
            getInsightIdentifierString(insightIdentifier);
        const storedFeedbackList = feedbackMap[insightIdentifierString];

        if (storedFeedbackList) {
            const matchingFeedback = storedFeedbackList.find(
                (feedback) =>
                    JSON.stringify(feedback.metadata) ===
                    JSON.stringify(metadata),
            );
            return matchingFeedback?.rating ?? null;
        }
    }
    return null;
};
